module.exports = __webpack_public_path__ + "img/start.4f104f1c.png";